/**
 * External dependencies
 */
import 'chartjs-adapter-moment';
import { Chart, registerables } from 'chart.js';

let setup = false;

export default () => {
    if (true === setup) {
        return;
    }

    Chart.register(...registerables);
    Chart.defaults.color = '#9087AC';
    Chart.defaults.font.family = 'Europa';
    Chart.defaults.font.size = 13;
    Chart.defaults.font.weight = 700;

    setup = true;
};
